import * as React from 'react';

class SlideButton extends React.Component {
  render() {
    return(
      <a href={this.props.targetLink} target="_blank" rel="noreferrer" className="slide-btn">
        <span className="circle">
          <i className="fa fa-download"></i>
        </span>
        <span className="title">{this.props.mainText}</span>
        <span className="title-hover">{this.props.hoverText}</span>
      </a>
    )
  }
}

export default SlideButton;
